import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import styled from "styled-components";
import { colors } from "../../../styles/figmaColors";
import fr from "react-phone-number-input/locale/fr";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";
import type { Value } from "react-phone-number-input";

interface PhoneProps {
  value: string;
  $update: (e: string) => void;
  error?: string;
  onKeyDown?: (e: KeyboardEvent) => void;
  $width?: number | string;
  $isError?: string;
}

export const PhoneInputDS = (props: PhoneProps) => {
  const { t } = useTranslation();
  return (
    <StyledPhoneInput
      onChange={(value: Value) =>
        props.$update(typeof value === "string" ? value : "")
      }
      value={props.value}
      defaultCountry={"FR"}
      labels={fr}
      onKeyDown={props.onKeyDown}
      $width={props.$width}
      $isError={props.$isError ?? props.error}
      placeholder={t("phoneInput.placeholder")}
    ></StyledPhoneInput>
  );
};

const StyledPhoneInput = styled(PhoneInput)<{
  $width?: string | number;
  $isError?: string;
  $isInputFocus?: boolean;
}>`
  select {
    font-size: 2rem;
  }
  input {
    width: ${({ $width }) => ($width ? `${$width}rem` : "100%")};
    height: 2rem;
    border: 0.0625rem solid
      ${({ $isError, $isInputFocus }) =>
        $isError
          ? colors["colors/system/error/error_normal"]
          : $isInputFocus
            ? colors["colors/accent/500"]
            : colors["colors/borders/input/default"]};
  }
  input:focus-visible {
    border: 0.0625rem solid ${colors["colors/accent/500"]};
  }
`;
